/**
 * Números de WhatsApp da Allu + builder de link wa.me.
 */
// Equipe / ajuda (botão flutuante do /parceiro/cadastro). +55 31 9930-8811.
export const WHATSAPP_NUMERO = "553199308811";

// CTA de alta carteira da /parceiros. Override via env VITE_WHATSAPP_PARCEIROS
// na Vercel (build-time: mudar a env exige redeploy). Aceita qualquer formato —
// não-dígitos são removidos. Fallback: +55 31 98266-5409 (Yago).
const envParceiros = (
  import.meta.env.VITE_WHATSAPP_PARCEIROS as string | undefined
)?.replace(/\D/g, "");
export const WHATSAPP_PARCEIROS = envParceiros || "5531982665409";

export function buildWhatsappLink(
  text?: string,
  numero: string = WHATSAPP_NUMERO
): string {
  const base = `https://wa.me/${numero}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
